<!-- Search Overlay -->
<div class="search-overlay" [class.active]="searchOverlayActive">
  <div class="search-container">
    <div class="search-header">
      <img
        src="../../../assets/images/logos/logo.svg"
        alt="logo"
        class="search-logo" />
      <button mat-icon-button (click)="toggleClasss()" class="close-search">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="search-input-container">
      <mat-form-field appearance="outline" class="search-field">
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearch($event)"
          placeholder="Type here to search for an item..."
          autocomplete="off" />
      </mat-form-field>
    </div>

    <div class="search-suggestions">
      <span class="suggestion-label">Search by:</span>
      <div class="suggestion-chips">
        <mat-chip-set>
          <mat-chip
            (click)="searchType = 'Corporate'; onSearchTypeChanged()"
            [class.selected]="searchType === 'Corporate'">
            <mat-icon matChipAvatar class="search-type-chip-icon">business</mat-icon>
            Companies
          </mat-chip>
          <mat-chip
            (click)="searchType = 'Contacts'; onSearchTypeChanged()"
            [class.selected]="searchType === 'Contacts'">
            <mat-icon matChipAvatar class="search-type-chip-icon">person</mat-icon>
            Contacts
          </mat-chip>
          <mat-chip
            (click)="searchType = 'Opportunities'; onSearchTypeChanged()"
            [class.selected]="searchType === 'Opportunities'">
            <mat-icon matChipAvatar class="search-type-chip-icon">trending_up</mat-icon>
            Opportunities
          </mat-chip>
          <mat-chip
            (click)="searchType = 'Deals'; onSearchTypeChanged()"
            [class.selected]="searchType === 'Deals'">
            <mat-icon matChipAvatar class="search-type-chip-icon">handshake</mat-icon>
            Deals
          </mat-chip>
          <mat-chip
            (click)="searchType = 'Lenders'; onSearchTypeChanged()"
            [class.selected]="searchType === 'Lenders'">
            <mat-icon matChipAvatar class="search-type-chip-icon">account_balance</mat-icon>
            Lenders
          </mat-chip>
          <mat-chip
            (click)="searchType = 'Appointments'; onSearchTypeChanged()"
            [class.selected]="searchType === 'Appointments'">
            <mat-icon matChipAvatar class="search-type-chip-icon">event</mat-icon>
            Appointments
          </mat-chip>
        </mat-chip-set>
      </div>
    </div>
  </div>

  <div class="search-results">
    @if (resultatsearch$) {
      <h2 class="search-results-title bold">
        {{ searchType }}:
        <span
          class="overlay-suggestions"
          *ngIf="resultatsearch$ | async as results"
          >{{ results.length }}</span
        >
      </h2>

      <ng-template #loading>
        <span *ngIf="searchTerm && searchTerm != ''">Loading...</span>
      </ng-template>

      <div
        class="row search-results-grid"
        [class.search-results-grid--three-cols]="
          searchType === 'Appointments' ||
          searchType === 'Opportunities' ||
          searchType === 'Deals'
        "
        *ngIf="resultatsearch$ | async as results; else loading">
        <div class="col-md-12 search-results-query">
          <ng-container *ngIf="searchTerm && searchTerm != ''">
            You are looking for : <b>{{ searchTerm }}</b>
          </ng-container>
        </div>

        <ng-container *ngFor="let result of results">
          <div
            class="col-md-4"
            *ngIf="
              searchType == 'Opportunities' &&
              (group.includes('superadmin') ||
                group.includes('admin') ||
                group.includes('busdev') ||
                group.includes('billing') ||
                group.includes('m_exec'))
            ">
            <div class="item search-result-card">
              <div class="search-result-card__header">
                <a
                  class="search-result-card__title-row"
                  routerLink="/crm/crm-opportunity-wizard/{{ result.slug }}/{{
                    result.slug_corporate
                  }}"
                  (click)="closeSearch()">
                  <mat-icon class="search-result-card__lead-icon">trending_up</mat-icon>
                  <span class="search-result-card__title-text ellipsis">{{ result.description }}</span>
                </a>
                <span
                  class="search-result-card__status-pill bg-light-{{ result.slug_status }} text-{{ result.slug_status }}"
                  >{{ result.statusname }}</span
                >
              </div>

              <div class="search-result-card__panel">
                <span class="search-result-card__panel-label">Company</span>
                <a
                  class="search-result-card__panel-link"
                  (click)="closeSearch()"
                  routerLink="/contact/corporate-details/{{ result.slug_corporate }}">
                  {{ result.namecorporate }}
                </a>
              </div> 

              <div class="search-result-card__chips-row">
                <span class="meta-chip" *ngIf="result.buname">
                  <strong>BU:</strong> {{ result.buname }}
                </span>
                <span class="meta-chip" *ngIf="result.dealnaturename">
                  <strong>Nature:</strong> {{ result.dealnaturename }}
                </span>
              </div>

              <div class="search-result-card__footer-meta" *ngIf="result.slug_busdev_in_charge">
                <strong>Busdev:</strong> {{ helper.getFullName(result.slug_busdev_in_charge) }}
              </div>

              <a
                class="search-result-card__icon-action"
                (click)="closeSearch()"
                routerLink="/crm/crm-opportunity-wizard/{{ result.slug }}/{{ result.slug_corporate }}"
                matTooltip="Open opportunity"
                matTooltipPosition="left"
                aria-label="Open opportunity">
                <mat-icon>open_in_new</mat-icon>
              </a>
            </div>
          </div>

          <div class="col-md-4" *ngIf="searchType == 'Deals'">
            <div class="item search-result-card" *ngIf="result.slug_status == 'live_deal'">
              <div class="search-result-card__header search-result-card__header--deal">
                <a
                  class="search-result-card__title-row search-result-card__title-row--wrap"
                  (click)="closeSearch()"
                  routerLink="/execution/deal-synopsis/{{ result.slugdeal }}">
                  <mat-icon class="search-result-card__lead-icon">handshake</mat-icon>
                  <span class="search-result-card__title-text search-result-card__title-text--multiline">{{
                    result.nomdeal
                  }}</span>
                </a>
              </div>

              <div class="search-result-card__panel">
                <span class="search-result-card__panel-label">Company</span>
                <a
                  class="search-result-card__panel-link"
                  (click)="closeSearch()"
                  routerLink="/contact/corporate-details/{{ result.slug }}">
                  {{ result.name }}
                </a>
              </div>

              <a
                class="search-result-card__icon-action"
                (click)="closeSearch()"
                routerLink="/execution/deal-synopsis/{{ result.slugdeal }}"
                matTooltip="Open deal"
                matTooltipPosition="left"
                aria-label="Open deal">
                <mat-icon>open_in_new</mat-icon>
              </a>
            </div>
          </div>

          <div class="col-md-4" *ngIf="searchType == 'Corporate'">
            <div class="item search-result-card search-entity-result">
              <div class="search-result-card__header search-result-card__header--stack">
                <a
                  class="search-result-card__title-row"
                  (click)="closeSearch()"
                  routerLink="/contact/corporate-details/{{ result.slug }}">
                  <mat-icon class="search-result-card__lead-icon">business</mat-icon>
                  <span class="search-result-card__title-text ellipsis search-entity-name-link">{{
                    result.name
                  }}</span>
                </a>
                <div class="search-badge-row" *ngIf="result.slug_category === 'management_company'">
                  <span class="search-badge search-badge--management">Management company</span>
                </div>
              </div>

              <div class="search-result-card__panel">
                <span class="search-result-card__panel-label">Profile</span>
                <div class="search-result-card__panel-lines">
                  <div *ngIf="result.categoryname">{{ result.categoryname }}</div>
                  <div *ngIf="result.souscategoryname">{{ result.souscategoryname }}</div>
                  <div class="search-text-capitalize" *ngIf="result.slug_country">
                    {{ result.slug_country }}
                  </div>
                </div>
              </div>

              <a
                class="search-result-card__icon-action"
                (click)="closeSearch()"
                routerLink="/contact/corporate-details/{{ result.slug }}"
                matTooltip="Open company"
                matTooltipPosition="left"
                aria-label="Open company">
                <mat-icon>open_in_new</mat-icon>
              </a>
            </div>
          </div>

          <div class="col-md-4" *ngIf="searchType == 'Contacts'">
            <div class="item search-result-card search-entity-result">
              <div class="search-result-card__header search-result-card__header--stack">
                <a
                  class="search-result-card__title-row"
                  (click)="closeSearch()"
                  routerLink="/contact/contact-details/{{ result.slug_corporate ?? 'null' }}/{{
                    result.id
                  }}">
                  <mat-icon class="search-result-card__lead-icon">person</mat-icon>
                  <span
                    class="search-result-card__title-text ellipsis search-entity-name-link search-contact-name-link"
                    >{{ result.name }} {{ result.forename }}</span
                  >
                </a>
                <div class="search-result-card__email-line">
                  <a
                    class="search-contact-email-link"
                    (click)="closeSearch()"
                    routerLink="/contact/contact-details/{{ result.slug_corporate ?? 'null' }}/{{
                      result.id
                    }}"
                    *ngIf="result.email; else noEmail">
                    {{ result.email }}
                  </a>
                  <ng-template #noEmail><span class="search-result-card__muted">—</span></ng-template>
                </div>
              </div>

              <div
                class="search-result-card__panel"
                *ngIf="
                  (result.corporate && result.corporate.length > 0) || isGenericContact(result)
                ">
                <span class="search-result-card__panel-label">Company(ies)</span>
                <div class="participants-chips">
                  <span
                    class="badge appointment-chip company-chip"
                    *ngFor="let corp of result.corporate ?? []"
                    >{{ corp.name }}</span
                  >
                  <span class="search-badge search-badge--generic" *ngIf="isGenericContact(result)">Generic</span>
                </div>
              </div>

              <a
                class="search-result-card__icon-action"
                (click)="closeSearch()"
                routerLink="/contact/contact-details/{{ result.slug_corporate ?? 'null' }}/{{ result.id }}"
                matTooltip="Open contact"
                matTooltipPosition="left"
                aria-label="Open contact">
                <mat-icon>open_in_new</mat-icon>
              </a>
            </div>
          </div>

          <div class="col-md-4" *ngIf="searchType == 'Lenders'">
            <div class="item search-result-card">
              <div class="search-result-card__header">
                <a
                  class="search-result-card__title-row"
                  (click)="closeSearch()"
                  routerLink="/contact/investor-overview/{{ result.slugcorporate }}/{{
                    result.sluglender
                  }}">
                  <mat-icon class="search-result-card__lead-icon">account_balance</mat-icon>
                  <span class="search-result-card__title-text ellipsis">{{ result.denomination }}</span>
                </a>
              </div>

              <div class="search-result-card__panel">
                <span class="search-result-card__panel-label">Company</span>
                <div class="search-result-card__panel-lines">{{ result.namecorporate || '—' }}</div>
              </div>

              <div class="search-result-card__panel" *ngIf="result.country">
                <span class="search-result-card__panel-label">Country</span>
                <div class="search-result-card__panel-lines">{{ result.country }}</div>
              </div>

              <a
                class="search-result-card__icon-action"
                (click)="closeSearch()"
                routerLink="/contact/investor-overview/{{ result.slugcorporate }}/{{ result.sluglender }}"
                matTooltip="Open lender"
                matTooltipPosition="left"
                aria-label="Open lender">
                <mat-icon>open_in_new</mat-icon>
              </a>
            </div>
          </div>

          <div
            class="col-md-4 appointment-result-col"
            *ngIf="
              searchType == 'Appointments' &&
              (group.includes('superadmin') ||
                group.includes('admin') ||
                group.includes('busdev') ||
                group.includes('crm_manager') ||
                group.includes('m_exec'))
            ">
            <div class="item appointment-card">
              <div class="appointment-header">
                <a
                  class="appointment-date-link"
                  (click)="navigateTo('/crm/crm-review-appointment/' + result.slug)">
                  <mat-icon class="appointment-icon">event</mat-icon>
                  <span>{{ result.date | date: 'dd/MM/yyyy' }}</span>
                </a>
                <a
                  class="appointment-open-icon-btn"
                  (click)="navigateTo('/crm/crm-review-appointment/' + result.slug)"
                  matTooltip="Go to the appointment"
                  matTooltipPosition="left"
                  aria-label="Go to the appointment">
                  <mat-icon>open_in_new</mat-icon>
                </a>
              </div>

              <div class="appointment-meta">
                <div
                  class="tweet-text appointment-row appointment-type-qualification"
                  *ngIf="result.typename || result.qualificationname || result.topic">
                  <span class="meta-chip" *ngIf="result.typename">
                    <strong>Type:</strong> {{ result.typename }}
                  </span>
                  <span class="meta-chip" *ngIf="result.qualificationname">
                    <strong>Qualification:</strong> {{ result.qualificationname }}
                  </span>
                  <span class="meta-chip" *ngIf="result.topic">
                    <strong>Topic:</strong> {{ result.topic }}
                  </span>
                </div>

                <div
                  class="tweet-text appointment-row"
                  *ngIf="result.list_of_company && result.list_of_company.length > 0">
                  <strong>Company(s):</strong>
                  <div class="participants-chips company-chips">
                    <span
                      class="badge appointment-chip company-chip"
                      *ngFor="let company of result.list_of_company">
                      {{ company }}
                    </span>
                  </div>
                </div>
              </div>

              <div
                class="tweet-text participants-block"
                *ngIf="
                  getExternalParticipants(result).length > 0 || getAfsParticipants(result).length > 0
                ">
                <strong>External participants:</strong>
                <div class="participants-chips" *ngIf="getExternalParticipants(result).length > 0">
                  <span
                    class="badge appointment-chip"
                    *ngFor="let participant of getExternalParticipants(result)">
                    {{ getParticipantDisplayName(participant) }}
                  </span>
                </div>
                <div *ngIf="getExternalParticipants(result).length === 0" class="tweet-text">
                  No external participants
                </div>
              </div>

              <div class="tweet-text participants-block">
                <strong>Creator:</strong>
                <div class="participants-chips" *ngIf="getSearchAppointmentCreator(result) as creator">
                  <span
                    class="badge appointment-chip afs-chip"
                    [ngClass]="getAppointmentCreatorClass('creator')">
                    {{ creator.name }}
                 
                  </span>
                </div>
                <div *ngIf="!getSearchAppointmentCreator(result)" class="tweet-text">
                  Unknown  
                </div>
              </div>

              <div class="tweet-text participants-block">
                <strong>Guest :</strong>
                <div class="participants-chips" *ngIf="getSearchInvitedAfsParticipants(result).length > 0">
                  <span
                    class="badge appointment-chip afs-chip"
                    *ngFor="let participant of getSearchInvitedAfsParticipants(result)">
                    {{ getParticipantDisplayName(participant) }}
                  </span>
                </div>
                <div *ngIf="getSearchInvitedAfsParticipants(result).length === 0" class="tweet-text">
                  None
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    }
  </div>
</div>
